import { useMemo } from "react";
import { BULK_COLUMNS, FAIL_COLUMNS } from "../constants/bulkUploadColumns";
import { VALIDATION_MAPPING } from "../constants/validationMapping";

const MESSAGES = {
    ORDERS: "Orders bulk file uploaded successfully",
    OUTSOURCE: "Outsources bulk file uploaded successfully",
    CLIENT: "Clients bulk file uploaded successfully",
    STAFF: "Staff bulk file uploaded successfully",
    DRIVERS: "Drivers bulk file uploaded successfully",
    ITEMS: "Items bulk file uploaded successfully",
    VEHICLES: "Vehicles bulk file uploaded successfully",
} as const;

export const useBulkConfig = (message?: string) => {
    return useMemo(() => {
        let type: keyof typeof MESSAGES | null = null;
        if (message) {
            for (const [k, v] of Object.entries(MESSAGES)) {
                if (message === v) {
                    type = k as keyof typeof MESSAGES;
                    break;
                }
            }
            if (!type) {
                const lower = message.toLowerCase();
                if (lower.includes("order")) type = "ORDERS";
                else if (lower.includes("outsource")) type = "OUTSOURCE";
                else if (lower.includes("client")) type = "CLIENT";
                else if (lower.includes("staff")) type = "STAFF";
                else if (lower.includes("driver")) type = "DRIVERS";
                else if (lower.includes("item")) type = "ITEMS";
                else if (lower.includes("vehicle")) type = "VEHICLES";
            }
        }
        const allColumns = type ? BULK_COLUMNS[type] : BULK_COLUMNS.OUTSOURCE;
        const failColumns = type ? FAIL_COLUMNS[type] : FAIL_COLUMNS.OUTSOURCE;
        const validationMessages = allColumns.map(c => VALIDATION_MAPPING[c.key] ?? c.key);
        return { allColumns, failColumns, validationMessages };
    }, [message]);
};